import { Outlet } from 'react-router-dom';
import ConsoleLayout from '@/components/layout/ConsoleLayout';
import { navLLMService } from '@/components/layout/navigation/configNav';
import useParamWorkspaceId from '@/hook/useParamWorkspaceId';
import { useAppState } from '@/store/app-state';
import { useEffect, useMemo } from 'react';
import useConsoleLayoutConfig from '@/hook/useConsoleLayoutConfig';

const LLMServiceLayout = () => {
  const { orgId, workspaceId } = useParamWorkspaceId();

  const navbarConfig = useMemo(
    () => ({
      title: 'LLM as a service',
      navbar: navLLMService(orgId, workspaceId),
    }),
    [orgId, workspaceId]
  );
  useConsoleLayoutConfig({
    navConfig: navbarConfig,
  });

  return (
    <div className="pt-8">
      <Outlet />
    </div>
  );
};

export default LLMServiceLayout;
